// Firefox folder extractor using webkitGetAsEntry
// This method is supported in Firefox 50+ and provides directory traversal capabilities

const FirefoxFolderExtractor = {
    isSupported() {
        // Check if we're in Firefox and webkitGetAsEntry is available
        const isFirefox = navigator.userAgent.toLowerCase().includes('firefox')
        const hasWebkitEntry = 'webkitGetAsEntry' in DataTransferItem.prototype
        return isFirefox && hasWebkitEntry
    },
    
    async extract(items) {
        const files = []
        const entries = []
        
        // Convert DataTransferItemList to array and get entries
        for (let i = 0; i < items.length; i++) {
            const item = items[i]
            if (item.kind === 'file') {
                const entry = item.webkitGetAsEntry()
                if (entry) {
                    entries.push(entry)
                }
            }
        }
        
        // Process each entry
        for (const entry of entries) {
            if (entry.isDirectory) {
                files.push(...await this.readDirectory(entry))
            } else if (entry.isFile) {
                const file = await this.getFileFromEntry(entry)
                if (file) {
                    files.push(file)
                }
            }
        }
        
        return files
    },
    
    async readDirectory(directoryEntry) {
        const files = []
        const reader = directoryEntry.createReader()
        
        // Read entries in batches (browser limitation: max 100 entries per read)
        let entries = []
        do {
            entries = await this.readEntries(reader)
            for (const entry of entries) {
                if (entry.isDirectory) {
                    // Recursively read subdirectories
                    files.push(...await this.readDirectory(entry))
                } else if (entry.isFile) {
                    const file = await this.getFileFromEntry(entry)
                    if (file) {
                        files.push(file)
                    }
                }
            }
        } while (entries.length > 0)
        
        return files
    },
    
    readEntries(reader) {
        return new Promise((resolve, reject) => {
            reader.readEntries(
                (entries) => resolve(entries),
                (error) => {
                    console.error('Error reading directory entries:', error)
                    resolve([]) // Return empty array on error to continue processing
                }
            )
        })
    },
    
    getFileFromEntry(fileEntry) {
        return new Promise((resolve, reject) => {
            fileEntry.file(
                (file) => {
                    // Preserve the full path in the file object for folder structure
                    Object.defineProperty(file, 'fullPath', {
                        value: fileEntry.fullPath,
                        writable: false,
                        enumerable: true,
                        configurable: true
                    })
                    resolve(file)
                },
                (error) => {
                    console.error('Error reading file:', error)
                    resolve(null) // Return null on error to continue processing
                }
            )
        })
    }
}

export default FirefoxFolderExtractor 